<template>
  <div>
    <DynamicModal
      :showModal="showModalProp"
      :persistent="false"
      @clickOutside="closeModal"
      title="Add One Off Fee"
      maxWidth="800px"
    >
      <v-container fluid slot="title-buttons" class="py-1">
        <v-row justify="end">
          <v-btn
            icon
            depressed
            color="primary"
            @click="closeModal"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid slot="content">
        <v-row class="mt-3">
          <v-col cols="12">
            <SimplePageHeader title="Assignment"></SimplePageHeader>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Consultant"
              v-bind:value="userName"
              readonly
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Client"
              v-bind:value="clientName"
              readonly
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <SimplePageHeader title="Fee"></SimplePageHeader>
          </v-col>
        </v-row>
        <v-form ref="OneOffFeeAddForm">
          <v-row class="mt-3">
            <v-col cols="12" sm="8">
              <v-text-field
                label="Description"
                v-model="description"
                validate-on-blur
                outlined
                :rules="[required('Description')]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <SimpleDatePicker
                :label="'Date'"
                :value="date"
                :isRequired="true"
                @selected-date-change="dateChangeHandler"
              ></SimpleDatePicker>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <FormattedNumberField
                label="Pay Amount"
                :value="payAmount"
                :required="true"
                prepend-inner-icon="attach_money"
                @valueChange="(newValue) => this.payAmount = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <FormattedNumberField
                label="Bill Amount"
                :value="billAmount"
                :required="true"
                prepend-inner-icon="attach_money"
                @valueChange="(newValue) => this.billAmount = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="notes"
                label="Notes"
                outlined
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-container fluid slot="buttons" class="pb-0 mb-0">
        <div class="row d-flex justify-end">
          <div class="col-6">
            <v-btn
              block
              depressed
              color="primary"
              @click="addOneOffFee"
            >
              Save
            </v-btn>
          </div>
          <div class="col-6">
            <v-btn
              block
              depressed
              outlined
              @click="closeModal"
            >
              Cancel
            </v-btn>
          </div>
        </div>
      </v-container>
    </DynamicModal>
  </div>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import SimplePageHeader from '@/components/pageComponents/SimplePageHeader'
import { SimpleDatePicker } from '@/components/shared/datePickers'
import required from '@/lib/formValidations/required'
import { mapActions } from 'vuex'
import ToDateOnlyString from '@/lib/display/toDateOnlyString'
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    DynamicModal,
    SimplePageHeader,
    SimpleDatePicker,
    FormattedNumberField
  },
  props: [
    'assignmentId',
    'userName',
    'clientName'
  ],
  data () {
    return {
      showModalProp: false,
      description: null,
      payAmount: null,
      billAmount: null,
      date: ToDateOnlyString(new Date()),
      notes: null
    }
  },
  methods: {
    ...mapActions('oneOffFeesRecords', ['saveOneOffFee']),
    showModal () {
      this.showModalProp = true
    },
    closeModal () {
      this.clearFee()
      this.showModalProp = false
      this.$emit('closeModal')
    },
    async addOneOffFee () {
      if (this.$refs.OneOffFeeAddForm.validate()) {
        await this.saveOneOffFee(Object.assign({}, {
          assignmentId: this.assignmentId,
          description: this.description,
          payAmount: this.payAmount,
          billAmount: this.billAmount,
          date: this.date,
          notes: this.notes
        }))
        this.clearFee()
        this.$refs.OneOffFeeAddForm.resetValidation()
        this.closeModal()
      }
    },
    dateChangeHandler (newDate) {
      this.date = newDate
    },
    clearFee () {
      this.description = null
      this.payAmount = null
      this.billAmount = null
      this.date = ToDateOnlyString(new Date())
      this.notes = null
      this.$refs.OneOffFeeAddForm.resetValidation()
    },
    required
  }
}
</script>
